/**
 * File home-scripts.js.
 *
 * Handles toggling the homepage intro
 *
 */

(function ($) {
  let $cta_home_intro = $('#header_intro--cta'),
    $cta_arrow = $('#header_intro--cta img'),
    $show_intro = $('.header_intro--show'),
    $intro_section = $('.header_intro'),
    $intro_opener = $('.header_intro .ms-inline-block'),
    count = 0;

  if (!$cta_home_intro.length || !$intro_section.length) {
    return;
  }

  $cta_home_intro.on('click', function () {
    toggleIntro();
    $('.header_contact').toggleClass('fade');
  });

  $intro_section.on('click', function () {
    if ($intro_section.hasClass('header_intro--expanded')) {
      count++;
      if (count == 2) {
        toggleIntro();
        $('.header_contact').toggleClass('fade');
      }
    } else {
      count = 0;
    }
  });

  function toggleIntro() {
    $intro_section.toggleClass('header_intro--expanded');
    $show_intro.toggleClass('show--intro');
    $intro_opener.toggleClass('opener--active');
    $cta_arrow.toggleClass('rotate');
    count = 0;
  }
})(jQuery);
